export default __webpack_public_path__ + "static/media/26-large.755e62f6.jpg";